import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

export const recepcionesRoutes: Routes = [
  {
    path: 'recepciones',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.RECEPCIONES_VER },
    loadComponent: () =>
      import('./pages/recepciones/recepciones.page').then((m) => m.RecepcionesPage),
    title: 'SiLabVet | Recepción de muestras',
  },
  {
    path: 'recepciones/nuevo',
    canActivate: [permisoGuard],
    // Con `copiaDe` en la URL el formulario llega desde la copia de un RT-01,
    // así que también entra quien solo tiene permiso de copiar.
    data: {
      permiso: [
        Permiso.RECEPCIONES_CREAR,
        Permiso.RECEPCIONES_PRIVADA_CREAR,
        Permiso.RECEPCIONES_COPIAR,
      ],
    },
    loadComponent: () =>
      import('./pages/recepcion-form/recepcion-form.page').then((m) => m.RecepcionFormPage),
    title: 'SiLabVet | Nueva recepción',
  },
  {
    // Fuera de `recepciones/`: el menú marca activa toda opción cuya ruta sea
    // prefijo de la URL, y se encenderían las dos.
    path: 'copia-recepcion',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.RECEPCIONES_COPIAR },
    loadComponent: () =>
      import('./pages/copia-recepcion/copia-recepcion.page').then((m) => m.CopiaRecepcionPage),
    title: 'SiLabVet | Copia de RT-01',
  },
  {
    path: 'recepciones/vigilancia',
    canActivate: [permisoGuard],
    data: { permiso: [Permiso.RECEPCIONES_CREAR, Permiso.RECEPCIONES_VIGILANCIA_CREAR] },
    loadComponent: () =>
      import('./pages/vigilancia/vigilancia.page').then((m) => m.VigilanciaPage),
    title: 'SiLabVet | Recepción por vigilancia epidemiológica',
  },
  {
    path: 'recepciones/:id/ver',
    canActivate: [permisoGuard],
    data: { soloLectura: true, permiso: Permiso.RECEPCIONES_VER },
    loadComponent: () =>
      import('./pages/recepcion-form/recepcion-form.page').then((m) => m.RecepcionFormPage),
    title: 'SiLabVet | Ver recepción',
  },
  {
    path: 'recepciones/:id/segunda-muestra',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.RECEPCIONES_EDITAR },
    loadComponent: () =>
      import('./pages/segunda-muestra/segunda-muestra.page').then((m) => m.SegundaMuestraPage),
    title: 'SiLabVet | Registrar segunda muestra',
  },
  {
    path: 'recepciones/:id/editar',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.RECEPCIONES_EDITAR },
    loadComponent: () =>
      import('./pages/recepcion-form/recepcion-form.page').then((m) => m.RecepcionFormPage),
    title: 'SiLabVet | Editar recepción',
  },
  {
    path: 'confirmacion-muestras',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.CONFIRMACION_VER },
    loadComponent: () =>
      import('./pages/confirmacion-muestras/confirmacion-muestras.page').then(
        (m) => m.ConfirmacionMuestrasPage,
      ),
    title: 'SiLabVet | Confirmación de muestras',
  },
];
